<template>
  <div
    class="popup"
    ref="popup"
    @keydown="popupKeydown"
    v-show="show"
    tabindex="0"
  >
    <div
      class="popup__overlay"
      :class="{ 'popup__overlay--hidden': !overlayActive }"
      @click="close"
    ></div>
    <div
      class="popup__window"
      :class="{ 'popup__window--hidden': !windowActive }"
    >
      <div class="popup__header">
        <div class="popup__header-buttons popup__header-buttons--left">
          <fa-icon
            v-for="btn in left_buttons"
            :key="btn.icon"
            class="popup__header-button"
            :icon="btn.icon"
            @click="btn.handler"
          ></fa-icon>
        </div>
        <h1>{{ title }}</h1>
        <div class="popup__header-buttons popup__header-buttons--right"></div>
      </div>
      <div class="popup__content">
        <slot></slot>
      </div>
      <div class="popup__buttons">
        <slot name="buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "left_buttons", "right_buttons"],
  data() {
    return {
      overlayActive: false,
      windowActive: false,
      show: false,
    };
  },
  methods: {
    async openWindowOnly() {
      this.show = true;
      await this.delayMs(50);
      this.windowActive = true;
    },
    closeWindowOnly() {
      this.windowActive = false;
    },
    async open() {
      this.show = true;
      await this.delayMs(200);
      this.overlayActive = true;
      this.windowActive = true;
      this.$refs.popup.focus();
    },
    async close(force) {
      if (!force && this.overlayActive !== this.windowActive) return;
      this.windowActive = false;
      this.overlayActive = false;
      await this.delayMs(200);
      this.show = false;
    },
    popupKeydown(e) {
      if (e.code === "Escape") this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  @include alignedFlex();
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: black;
    transition: opacity 0.2s ease;
    opacity: 0.4;

    &--hidden {
      opacity: 0;
    }
  }

  &__content {
    max-height: 90vh;
    width: 100%;
    margin: 0 auto;
    overflow-y: auto;
  }

  &__buttons {
    width: 70%;
    margin: 12px auto 0 auto;
    display: flex;
    justify-content: center;

    & > * {
      margin: 0 7px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 4%;
    padding: 2% 0;
    font-size: 0.85em;
    & > h1 {
      margin: 7px 0 10px 0;
    }
  }

  &__header-buttons {
    display: flex;
    position: relative;
    height: 4%;
    min-width: 90px;
    padding: 2.75% 0 2% 0;
    top: 0;
    font-size: 20px;
    font-size: 1.4em;

    &--left {
      left: 2%;
    }

    &--right {
      right: 2%;
    }
  }

  &__header-button {
    cursor: pointer;
  }

  &__window {
    max-width: 75%;
    max-height: 85%;
    background: white;
    border-radius: 4px;
    z-index: 35;
    transition: transform 0.4s ease;
    overflow: hidden;
    will-change: transform;
    padding: 0 25px;
    padding-bottom: 20px;

    &--hidden {
      transform: translateY(-250vh);
    }
  }
}
</style>
